<template>
    <div :class="$attrs.class">
        <button
            type="button"
            class="bg-card border-stroke-1 flex h-12 w-full min-w-30 items-center justify-center gap-2 border px-6 text-sm leading-5 font-black tracking-[0.25px] text-white uppercase"
            @click="visible = true"
        >
            <span class="truncate">
                {{ presets.find((p) => p.value === modelValue)?.label || $t('general.select') }}
            </span>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="shrink-0"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.0001 13.5856L6.70718 8.29274L5.29297 9.70696L12.0001 16.4141L18.7072 9.70695L17.293 8.29274L12.0001 13.5856Z"
                    fill="white"
                />
            </svg>
        </button>

        <BottomSheet :open="visible" @close="visible = false">
            <template #title>
                <slot></slot>
            </template>
            <div class="w-full gap-2" :class="isGrid ? 'grid grid-cols-2' : 'flex overflow-x-auto'">
                <diagonal-cut-button
                    v-for="(preset, index) in presets"
                    :key="preset.value"
                    class="h-12 flex-1 *:text-sm *:font-black"
                    :class="{
                        'clip-both-corners': !isGrid && index !== 0 && index !== presets.length - 1,
                    }"
                    :cut-position="cutPosition(index)"
                    :variant="modelValue == preset.value ? 'primary' : 'secondary'"
                    @click="selectPreset(preset.value)"
                    borderColor="bg-zinc-700"
                    fillColor="bg-card"
                    >{{ preset.label }}</diagonal-cut-button
                >
            </div>
        </BottomSheet>
    </div>
</template>

<script>
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'
import BottomSheet from '@/components/ui/BottomSheet.vue'

export default {
    name: 'SelectDrawer',
    inheritAttrs: false,
    components: {
        DiagonalCutButton,
        BottomSheet,
    },
    props: {
        modelValue: {
            default: 0,
        },
        presets: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    computed: {
        isGrid() {
            return this.presets.length > 3
        },
    },
    methods: {
        cutPosition(index) {
            if (this.isGrid) {
                return index % 2 === 0 ? 'right-top' : 'left-top'
            }
            return index === 0 ? 'right-top' : undefined
        },
        selectPreset(value) {
            this.visible = false
            this.$emit('update:modelValue', value)
        },
    },
}
</script>
